module.exports = __webpack_public_path__ + "static/img/report01.b4aa8658.png";